import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem, MatListItemTitle, MatListItemMeta } from '@angular/material/list';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { PageToolbarComponent, SummaryCardComponent } from '@next/core-lib/components';
import { LocaleService, TranslatePipe } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { take } from 'rxjs/operators';

import { ReferenceValueSheet } from '../../models/reference-value-sheet.model';
import * as refValSheetActions from '../../store/reference-value-sheet.actions';
import { getStandardReferenceValueSheets } from '../../store/reference-value-sheet.selectors';

@Component({
  selector: 'app-create-reference-value-sheet-from-standard',
  templateUrl: './create-reference-value-sheet-from-standard.component.html',
  styleUrls: ['./create-reference-value-sheet-from-standard.component.scss'],
  imports: [
    PageToolbarComponent,
    SummaryCardComponent,
    MatList,
    MatListItem,
    MatListItemTitle,
    MatButton,
    MatListItemMeta,
    MatIcon,
    NgIf,
    NgFor,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class CreateRefValSheetFromStandardComponent {
  private readonly store = inject<Store<RootState>>(Store);
  private readonly locale = inject(LocaleService);

  /* SELECTORS & DATA */
  standardRefValSheets$: Observable<ReferenceValueSheet[]> = this.store.select(
    getStandardReferenceValueSheets,
  );

  /* INDICATORS */
  isAdvisor = false;

  authorization$: Observable<boolean> = this.store.pipe(
    select(AuthorizationSelectors.hasAtLeastAdvisorRole),
  );

  ltr$ = this.locale.ltr$;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    this.store.dispatch(refValSheetActions.clearRefValSheetState());
    this.store.dispatch(refValSheetActions.loadStandardRefValSheetsByCountryRequest());
    this.store.dispatch(refValSheetActions.setBaseRefValSheetRequest({ refValSheet: null }));

    this.authorization$.pipe(take(1)).subscribe((hasAtLeastAdvisorRole) => {
      this.isAdvisor = hasAtLeastAdvisorRole;
    });
  }

  fromScratchCreate() {
    if (this.isAdvisor) {
      this.store.dispatch(refValSheetActions.createRefValSheetNavigation({ isStandard: false }));
    }
  }

  createRefValSheetFromStandard(refValSheet: ReferenceValueSheet) {
    if (this.isAdvisor) {
      const base = refValSheet as ReferenceValueSheet;
      this.store.dispatch(refValSheetActions.setBaseRefValSheetRequest({ refValSheet: base }));
      this.store.dispatch(refValSheetActions.createRefValSheetNavigation({ isStandard: false }));
    }
  }
}
